import { useParams } from 'react-router-dom';

const useAppParams = useParams<{ vid: string; schematic: string }>;

export default useAppParams;
